<script>
import {
  monCompteCommandeOverviewProps,
  useMonCompteCommandeOverview
} from "./mixin";
import Divider from "@/components/atoms/divider";
import Icon from "@/components/atoms/icon";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Card from "@/components/molecules/card";
import IconShipping from "@/components/molecules/icon-shipping";
import BadgeStatus from "@/components/molecules/badge-status";
import LinkComponent from "@/components/atoms/link-to/link";

export default {
  name: "CommandeOverviewMobile",
  components: {
    Divider,
    GridRow,
    GridCol,
    Card,
    Icon,
    BadgeStatus,
    IconShipping,
    LinkComponent
  },
  props: {
    ...monCompteCommandeOverviewProps()
  },
  setup(props) {
    const { badgeVariant, isLDD } = useMonCompteCommandeOverview(props);
    return { badgeVariant, isLDD };
  }
};
</script>

<template>
  <Card
    radius="lg"
    elevation="sm"
  >
    <LinkComponent
      class="c-commande-overview-mobile__button u-p-sm"
      :to="
        `/mon-compte/mes-commandes/${commande.id}?archive=${commande.attributes.is_archive}`
      "
    >
      <div class="u-flex u-flex-align-center">
        <div class="u-flex-item-fluid u-pr-md">
          <GridRow class="u-text-left u-pb-xs">
            <GridCol cols="8">
              <p class="u-text-ellipsis u-font-15">
                <strong class="u-font-500">
                  {{ commande.attributes.code }}
                </strong>
                <template v-if="commande.attributes.titre">
                  <br />
                  {{ truncate(commande.attributes.titre, 15) }}
                </template>
              </p>
              <p class="u-font-15 u-mt-xxs">
                {{ dateCommande(commande.attributes.date_commande) }}
              </p>
            </GridCol>
            <GridCol cols="4">
              <p class="u-font-15 u-text-right">
                <strong>
                  {{ formatPrix(commande.attributes.montant_total_ttc) }}
                  &nbsp;€
                </strong>
              </p>
            </GridCol>
          </GridRow>
          <Divider
            dotted
            class="u-m-none"
          />
          <div class="u-text-left u-mt-xs u-mb-xs">
            <IconShipping
              :type="commande.attributes.code_type_commande"
              variant="primary"
              size="sm"
            >
              <span class="u-font-15">
                {{ commande.attributes.type_commande }}
                <template v-if="isLDD">
                  <br />
                  Exclu Web
                </template>
              </span>
            </IconShipping>
          </div>
          <div class="u-text-left">
            <BadgeStatus
              size="sm"
              :status="badgeVariant"
              class="u-ml-xxs"
            >
              {{ commande.attributes.statut }}
            </BadgeStatus>
          </div>
        </div>
        <Icon
          name="arrow-right"
          size="md"
          class="u-flex-shrink-none"
        />
      </div>
    </LinkComponent>
  </Card>
</template>

<style lang="scss" scoped>
.c-commande-overview-mobile__button {
  display: block;
  width: 100%;
  text-decoration: none;
}
</style>
